
export default function fileToBase64 (file) {
	const deferred = $.Deferred();
	const fReader = new FileReader();
	fReader.readAsDataURL(file);
	fReader.addEventListener('load', (e) => {
		deferred.resolve(e.target.result);
	});
	fReader.addEventListener('error', (e) => {
		deferred.reject(fReader.error);
	});
	return deferred;
}
